import {FIELDS_PATTERN} from 'src/modules/event-create/constants';

const MIN_LENGTH_TRIGGER = 3;
export const MAX_LENGTH_TRIGGER = 1000;

const ERROR_MESSAGES = {
    EVENT_TRIGGER_MIN_LENGTH: 'Please enter correct "Trigger". "Trigger" length must be more than 2 characters',
    EVENT_TRIGGER_WRONG_CHARACTERS: 'Please enter correct "Trigger". ' +
        'Use latin alphabet and symbols: . , ( – " \' ) / + - : &',
};

export const eventTriggerValidation = (eventTrigger: string): string[] => {
    const errorMassages = [];
    const matches = eventTrigger.match(FIELDS_PATTERN.trigger);

    if (eventTrigger.length < MIN_LENGTH_TRIGGER) {
        errorMassages.push(ERROR_MESSAGES.EVENT_TRIGGER_MIN_LENGTH);
    }

    if (matches) {
        errorMassages.push(ERROR_MESSAGES.EVENT_TRIGGER_WRONG_CHARACTERS);
    }
    return errorMassages;
};
